.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 500;
}

.modal {
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--kh-radius-card);
  box-shadow: var(--kh-shadow-modal);
  padding: var(--kh-space-7);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--kh-space-6);
  width: 320px;
}

.title {
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  letter-spacing: 0.01em;
}

.previewWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.previewCircle {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  background: #333;
  flex-shrink: 0;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.15);
}

.previewImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform-origin: center;
  user-select: none;
}

.sliderRow {
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--kh-space-3);
}

.sliderLabel {
  color: rgba(255, 255, 255, 0.5);
  font-size: var(--kh-size-meta);
  white-space: nowrap;
  flex-shrink: 0;
}

.slider {
  flex: 1;
  appearance: none;
  height: 3px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.2);
  outline: none;
  cursor: pointer;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  border: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.actions {
  display: flex;
  gap: var(--kh-space-3);
  width: 100%;
}

.cancelBtn {
  flex: 1;
  padding: 9px 0;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--kh-radius-sm);
  color: rgba(255, 255, 255, 0.7);
  font-size: var(--kh-size-body);
  cursor: pointer;
  transition: background var(--kh-duration-fast);
}

.cancelBtn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.13);
  color: #fff;
}

.saveBtn {
  flex: 1;
  padding: 9px 0;
  background: var(--kh-red);
  border: none;
  border-radius: var(--kh-radius-sm);
  color: #fff;
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  cursor: pointer;
  transition: background var(--kh-duration-fast);
}

.saveBtn:hover:not(:disabled) {
  background: var(--kh-red-dark);
}

.cancelBtn:disabled,
.saveBtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
